import { React, Settings, variantProvider } from '@/app'
import { useAppSelector } from '@/redux'
import { useDebug } from '@/utils'
import { useBooleanToggle } from '@codeleap/common'
import { ActionIcon, Button, Modal, View } from '@codeleap/web'
import { LanguageSelector } from '../LanguageSelector'
import { navigate } from 'gatsby'

export const DebugButtons = ({ toggle }) => {
  const debug = useDebug()

  return <View variants={['gap:2', 'column']}>
    <LanguageSelector onPress={toggle} />
    <Button
      debugName={'Submit logs'}
      text={'Submit logs'}
      onPress={debug.submitLogs}
    />

    <Button
      debugName={'Test Sentry crash'}
      text={'Test Sentry crash'}
      onPress={debug.testSentryCrash}
    />

    <Button
      debugName={'Test undefined.fuuuuu()'}
      text={'Test undefined.fuuuuu()'}
      onPress={debug.testUndefinedFunctionCall}
    />

    <Button
      debugName={'Test try catch'}
      text={'Test try catch'}
      onPress={debug.testTryCatch}
    />

    <Button
      debugName={'Test throwing an error'}
      text={'Test throwing an error'}
      onPress={debug.testThrowError}
    />

    <Button
      debugName={'Test logger.warn'}
      text={'Test logger.warn'}
      onPress={debug.testLoggerWarn}
    />

    <Button
      debugName={'Test logger.error'}
      text={'Test logger.error'}
      onPress={debug.testLoggerError}
    />

    <Button
      debugName={'Test logging circular dependency'}
      text={'Test logging circular dependency'}
      onPress={debug.testLoggingCircularDeps}
    />

    <Button
      debugName={'debugModal: go to components'}
      text={'Components'}
      onPress={() => {
        toggle()
        navigate('/components/')
      }}
    />

    <Button
      debugName={'debugModal: go to auth screens'}
      text={'AuthScreens'}
      onPress={() => {
        toggle()
        navigate('/auth/screens/')
      }}
    />
  </View>
}

export const DebugModal = () => {
  const [debugVisible, debugToggle] = useBooleanToggle(false)
  const isDev = useAppSelector(store => store.AppStatus.isDev)

  if (!isDev && !Settings.Environment.IsDev) return null

  return <>
    <ActionIcon
      icon='bug'
      onPress={debugToggle}
      debugName={'Debug modal button'}
      variants={['bg:primary3']}
      iconProps={{ variants: ['medium'] }}
      css={styles.bugButton}
    />

    <Modal visible={debugVisible} toggle={() => debugToggle(!debugVisible)} debugName={'Debug modal'} title='Debug' showClose variants={['centered']} >
      <DebugButtons toggle={() => debugToggle(!debugVisible)} />
    </Modal>
  </>
}

const styles = variantProvider.createComponentStyle((theme) => ({
  bugButton: {
    ...theme.presets.fixed,
    right: theme.spacing.value(2),
    bottom: theme.spacing.value(2),
    zIndex: 9,
  },
  wrapper: {
    ...theme.presets.center,
    backgroundColor: theme.colors.primary4,
    ...theme.spacing.padding(1),
    borderRadius: theme.borderRadius.small,
  },
}), true)
